import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = /*#__PURE__*/_createElementVNode("rect", {
  x: "1.59998",
  y: "1.60156",
  width: "12.8",
  height: "12.8",
  rx: "0.64",
  fill: "#D7AA0F"
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.00116 5.60156V8.80156M7.99548 11.2016H8.00005",
  stroke: "white",
  "stroke-width": "1.336",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1);
const _hoisted_4 = [_hoisted_2, _hoisted_3];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 16 16",
    fill: "none"
  }, _hoisted_4, 8, _hoisted_1);
}